import { PaymentGuideStepper } from './PaymentGuideStepper';
import { PaymentGuideType } from './PaymentGuideType';

export const bogotaBalanceBehindPaymentSteps: PaymentGuideStepper[] = [
  {
    type: PaymentGuideType.AVAL_PAY_CENTER,
    steps: [
      { text: '1. Ingresa a Aval Pay Center a la cuenta Recaudo Acuerdo De Pago Banco Bogotá (Link: [https://www.avalpaycenter.com/wps/portal/portal-de-pagos.)](https://www.avalpaycenter.com/wps/portal/portal-de-pagos.))' },
      { text: '2. En la búsqueda para pagos escribir la palabra "**Acuerdos**".' },
      { text: '3. Escoger la opción "**ACUERDOS DE PAGO BANCO Bta”**' },
      { text: '4. Ingresa el número de tu obligación.' },
      { indents: 1, text: '**a. Pago Tarjeta de Crédito**: Se deben ingresar los 16 dígitos de la tarjeta seguido del número de cédula y completar el campo de tu número de cédula.' },
      { indents: 1, text: '**b. Pago Crédito:** Ingresar únicamente los números de la obligación y diligenciar el campo de tu número de cédula.' },
      { text: '5. Selecciona "**Pago parcial**" e ingresa el valor exacto de la cuota a pagar.' },
      { text: '6. Acepta términos y condiciones y da click en el botón "**Pagar"**.' },
      { text: '7. Continuar los pasos para pago PSE, ingresando los datos del titular del producto de donde saldrá el dinero y realiza la pasarela de pagos.' },
    ],
  },
  {
    type: PaymentGuideType.PHYSICAL,
    steps: [
      { text: '1. Solicitar formato de consignación **\'SNR\'** Sistema Nacional de Recaudo' },
      { text: '2. Diligenciar formato así: ' },
      { indents: 1, text: '**2.1.** En número de cuenta registrar **00077817-5** ' },
      { indents: 1, text: '**2.2.** En nombre de convenio registrar: **\'Normalización de cartera temprana\'**.' },
      { indents: 1, text: '**2.3.** En ref 1 registrar el número de cédula del titular. ' },
      { indents: 1, text: '**2.4.** En ref 2 registrar número completo de la obligación a normalizar y demás datos del pago.' },
      { text: '3. Hacer pago en caja.' },
    ],
  },
];
